"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTING_OPTIONAL_ACCOUNT_MAPPING_SLOTS = exports.ACCOUNTING_REQUIRED_ACCOUNT_MAPPING_SLOTS = exports.AccountingAccountMappingSlot = exports.ACCOUNTING_ACCOUNT_MAPPING_HANDSHAKE_REF_DEFAULT = exports.ACCOUNTING_PROVIDER_DISPLAY_NAMES = exports.AccountingSyncIdempotencyStatus = exports.BusinessAccountingConnectionStatus = exports.AccountingProviderStatus = void 0;
exports.isAccountingSyncRetriableFailure = isAccountingSyncRetriableFailure;
exports.isAccountingSyncTerminalFailure = isAccountingSyncTerminalFailure;
var AccountingProviderStatus;
(function (AccountingProviderStatus) {
    AccountingProviderStatus["ACTIVE"] = "ACTIVE";
    AccountingProviderStatus["DISABLED"] = "DISABLED";
    AccountingProviderStatus["DEPRECATED"] = "DEPRECATED";
})(AccountingProviderStatus || (exports.AccountingProviderStatus = AccountingProviderStatus = {}));
var BusinessAccountingConnectionStatus;
(function (BusinessAccountingConnectionStatus) {
    BusinessAccountingConnectionStatus["NOT_CONNECTED"] = "NOT_CONNECTED";
    BusinessAccountingConnectionStatus["CONNECTING"] = "CONNECTING";
    BusinessAccountingConnectionStatus["CONNECTED"] = "CONNECTED";
    BusinessAccountingConnectionStatus["FAILED"] = "FAILED";
})(BusinessAccountingConnectionStatus || (exports.BusinessAccountingConnectionStatus = BusinessAccountingConnectionStatus = {}));
var AccountingSyncIdempotencyStatus;
(function (AccountingSyncIdempotencyStatus) {
    AccountingSyncIdempotencyStatus["IN_PROGRESS"] = "IN_PROGRESS";
    AccountingSyncIdempotencyStatus["SUCCEEDED"] = "SUCCEEDED";
    AccountingSyncIdempotencyStatus["FAILED"] = "FAILED";
    /** Retry budget exhausted; row is not picked up by the failed-sync worker. Filter on this instead of FAILED. */
    AccountingSyncIdempotencyStatus["RETRY_EXHAUSTED"] = "RETRY_EXHAUSTED";
})(AccountingSyncIdempotencyStatus || (exports.AccountingSyncIdempotencyStatus = AccountingSyncIdempotencyStatus = {}));
/** Rows the failed-sync worker may still pick up (`retry_count` cap applies separately). */
function isAccountingSyncRetriableFailure(status) {
    return status === AccountingSyncIdempotencyStatus.FAILED;
}
/** FAILED or RETRY_EXHAUSTED — use for UI error state and ops dashboards. */
function isAccountingSyncTerminalFailure(status) {
    return (status === AccountingSyncIdempotencyStatus.FAILED ||
        status === AccountingSyncIdempotencyStatus.RETRY_EXHAUSTED);
}
exports.ACCOUNTING_PROVIDER_DISPLAY_NAMES = {
    xero: "Xero",
    quickbooks: "QuickBooks",
};
/** Fixed handshake ref for org-wide default account slots (unique with mappingType). */
exports.ACCOUNTING_ACCOUNT_MAPPING_HANDSHAKE_REF_DEFAULT = "default";
/**
 * Account slots Handshake needs before invoice / sync flows.
 * Stored as `mapping_type` with `handshake_ref` = {@link ACCOUNTING_ACCOUNT_MAPPING_HANDSHAKE_REF_DEFAULT}.
 */
var AccountingAccountMappingSlot;
(function (AccountingAccountMappingSlot) {
    AccountingAccountMappingSlot["DEFAULT_REVENUE"] = "DEFAULT_REVENUE";
    /**
     * P&L account for platform / Nucleus charges.
     * Fee posts as a bank entry at pay-in (Dr charges / Cr bank) — not as a sales-invoice line (HAN-410 / HAN-420).
     */
    AccountingAccountMappingSlot["HANDSHAKE_PLATFORM_FEE"] = "HANDSHAKE_PLATFORM_FEE";
    /**
     * Contract liability / deferred revenue for Handshake + Nucleus — ACCREC lines at create (milestone only);
     * fund release reclassifies liability → {@link AccountingAccountMappingSlot.DEFAULT_REVENUE} via manual journal.
     * Platform fee posts at pay-in (HAN-410 / HAN-458 / HAN-461).
     */
    AccountingAccountMappingSlot["CONTRACT_LIABILITY"] = "CONTRACT_LIABILITY";
    /**
     * Handshake **escrow** bank (Finmo ESCROW). Pay-in payments allocate here; Nucleus platform-charge credit
     * also uses this slot as clearing. HAN-420.
     */
    AccountingAccountMappingSlot["HANDSHAKE_ESCROW_BANK"] = "HANDSHAKE_ESCROW_BANK";
    /**
     * Handshake **actual** bank (Finmo ACTUAL). Handshake platform-charge credit, escrow→actual release journals,
     * and withdrawal **from** this account. HAN-420.
     */
    AccountingAccountMappingSlot["HANDSHAKE_ACTUAL_BANK"] = "HANDSHAKE_ACTUAL_BANK";
    /**
     * @deprecated Renamed to {@link AccountingAccountMappingSlot.HANDSHAKE_ESCROW_BANK}.
     * Existing DB rows may still use this value — dual-read via escrow lookup helpers.
     */
    AccountingAccountMappingSlot["ACCOUNTS_RECEIVABLE"] = "ACCOUNTS_RECEIVABLE";
    /**
     * Expense account for **absorbed credit card / transaction fees** when the business absorbs the CC markup.
     * This is optional because the business may choose a different accounting setup, and we must not block
     * invoice/payment sync when it is unmapped.
     */
    AccountingAccountMappingSlot["CREDIT_CARD_FEE_EXPENSE"] = "CREDIT_CARD_FEE_EXPENSE";
    /**
     * Operating bank that receives withdrawal payouts (transfer **to** this account).
     * Must be a different bank account from escrow and actual.
     */
    AccountingAccountMappingSlot["WITHDRAWAL_DESTINATION_BANK"] = "WITHDRAWAL_DESTINATION_BANK";
    /** @deprecated Renamed to {@link AccountingAccountMappingSlot.WITHDRAWAL_DESTINATION_BANK}. DB rows may still use this value. */
    AccountingAccountMappingSlot["WITHDRAWAL_SOURCE_BANK"] = "WITHDRAWAL_SOURCE_BANK";
    /** @deprecated No longer used (withdrawals are bank transfers, not spend-money + expense). */
    AccountingAccountMappingSlot["WITHDRAWAL_EXPENSE"] = "WITHDRAWAL_EXPENSE";
})(AccountingAccountMappingSlot || (exports.AccountingAccountMappingSlot = AccountingAccountMappingSlot = {}));
exports.ACCOUNTING_REQUIRED_ACCOUNT_MAPPING_SLOTS = [
    AccountingAccountMappingSlot.DEFAULT_REVENUE,
    AccountingAccountMappingSlot.HANDSHAKE_PLATFORM_FEE,
    AccountingAccountMappingSlot.CONTRACT_LIABILITY,
    AccountingAccountMappingSlot.HANDSHAKE_ESCROW_BANK,
    AccountingAccountMappingSlot.HANDSHAKE_ACTUAL_BANK,
    AccountingAccountMappingSlot.WITHDRAWAL_DESTINATION_BANK,
];
/**
 * Optional mappings — omitting skips only the flows that need them.
 */
exports.ACCOUNTING_OPTIONAL_ACCOUNT_MAPPING_SLOTS = [
    AccountingAccountMappingSlot.CREDIT_CARD_FEE_EXPENSE,
];
